module.exports = __webpack_public_path__ + "static/media/resumap.5649d2c8.png";